/* ==========================================================================
   STICKR LAB · CUSTOM VINYL STICKERS  ·  vinyl.js
   The only JavaScript this page needs. No dependencies.
   Scroll reveal only: adds .is-in once on entry, with a scroll fallback and a
   2s hard timeout so content can NEVER stay invisible if IntersectionObserver
   fails to fire (embedded previews, some in-app browsers).
   The FAQ is native <details>/<summary>. The page is fully usable with JS off -
   reveals simply start visible under prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('.sl-vs');
  if (!root) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = root.querySelectorAll('.sl-vs-rev');

  function showAll() { for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-in'); }
  if (reduced || !('IntersectionObserver' in window)) { showAll(); return; }

  var ioFired = false;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      ioFired = true; e.target.classList.add('is-in'); io.unobserve(e.target);
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
  for (var i = 0; i < targets.length; i++) io.observe(targets[i]);

  function sweep() {
    var pending = false;
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      if (t.classList.contains('is-in')) continue;
      if (t.getBoundingClientRect().top < window.innerHeight * 0.92) { t.classList.add('is-in'); io.unobserve(t); }
      else pending = true;
    }
    if (!pending) window.removeEventListener('scroll', sweep);
  }
  window.addEventListener('scroll', sweep, { passive: true });
  setTimeout(function () {
    if (!ioFired && !root.querySelector('.sl-vs-rev.is-in')) showAll(); else sweep();
  }, 2000);
})();
